import * as types from '../constants/ActionTypes'

const initialState = {
  loginState: 0,
  user: {}
}

const auth = (state = initialState, action) => {

  switch (action.type) {
    case types.REDUCER_SET_AUTH:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default auth


// WEBPACK FOOTER //
// ./src/reducers/auth.js